// extracted by css-extract-rspack-plugin
export default {"card":"nZ5QTH","attemptText":"pujUfT"};